import type {
  ResolvedStepRules,
  StepRulesContext,
} from '@ngb-frontend/shared/types'

/**
 * Resolve which optional journey steps are offered for the session. Consumed by
 * the static step-skip predicates so they branch on capabilities instead of raw
 * `isLPSystem` / country-config checks.
 */
export const resolveStepRules = (ctx: StepRulesContext): ResolvedStepRules => {
  const isLP = !!ctx.isLPSystem
  const hasConfiguredExtras = Object.values(
    ctx.countryConfig?.additionalServices ?? {},
  ).some(Boolean)

  return {
    // Inspection and replacement vehicle are LeasePlan-only features
    inspectionOffered: isLP,
    replacementVehicleOffered: isLP,
    autopickSupplier: !!ctx.countryConfig?.autopickPNRSupplier,
    // LeasePlan always offers extras; Ayvens depends on its configured
    // additional services. Absent config → not skipped (treated as offered).
    offersAnyExtraService: isLP || !ctx.countryConfig || hasConfiguredExtras,
  }
}
